import { useCallback, useEffect, useRef, useState } from 'react'

import { checkPauseOf } from './connection'

/**
 * Повтор «кто я» на входе, пока сервер входа не ответил (RP-SALE-FAST, К-111): раньше первый же сбой `/auth/me` оставлял «Сервер входа
 * недоступен» без кнопки и без повтора, пока человек не нажимал F5. Паузы — те же, что у `ConnectionMonitor`
 * (`HEALTH_TIMINGS.serverCheckPausesMs`: 1, 2, 4, 8, дальше каждые 10 с). `failed` — запрос завершился ошибкой (идущий сейчас повтор
 * её снимает до нового итога, поэтому таймер на время запроса не заводится); `retryNow` — кнопка «Повторить»: попытка немедленно.
 * Связь, вернувшаяся раньше таймера, перечитывает вход отдельно (`useRefetchOnReconnect` в `SessionGate`).
 */
export function useGateRetry(failed: boolean, refetch: () => unknown): { attempts: number; retryNow: () => void } {
  const [attempts, setAttempts] = useState(0)
  const latest = useRef(refetch)
  useEffect(() => {
    latest.current = refetch
  })
  const retryNow = useCallback(() => {
    setAttempts((count) => count + 1)
    try {
      void latest.current()
    } catch {
      // Подписка снята между рендерами: перечитывать нечего.
    }
  }, [])
  useEffect(() => {
    if (!failed) return undefined
    const timer = window.setTimeout(retryNow, checkPauseOf(attempts))
    return () => window.clearTimeout(timer)
  }, [failed, attempts, retryNow])
  return { attempts, retryNow }
}
